import { Link } from "react-router-dom";
import SectionTitle from "@/components/feature/SectionTitle";
import { categories } from "@/mocks/site";

export default function CategoryGrid() {
  const list = categories.filter((c) => c.id !== "all");

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <SectionTitle
        eyebrow="主题分类"
        title="按板块找到你想看的讨论"
        desc="不同板块的讨论氛围完全不同，选一个感兴趣的方向，直接进入对应的话题列表。"
      />

      <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {list.map((category, index) => (
          <Link
            key={category.id}
            to={`/topics?category=${category.id}`}
            className={`group rounded-2xl p-5 md:p-6 border transition-colors flex items-start gap-4 ${
              index === 0
                ? "bg-primary-500 border-primary-500 text-background-50"
                : "bg-background-50 border-background-200 hover:border-secondary-300"
            }`}
          >
            <span
              className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${
                index === 0
                  ? "bg-background-50/20 text-background-50"
                  : "bg-secondary-100 text-secondary-700"
              }`}
            >
              <i className={`${category.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <h3
                className={`text-base md:text-lg font-bold ${
                  index === 0 ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {category.name}
              </h3>
              <p
                className={`mt-1.5 text-sm leading-relaxed ${
                  index === 0 ? "text-background-100/85" : "text-foreground-600"
                }`}
              >
                {category.desc}
              </p>
              <span
                className={`mt-3 inline-flex items-center gap-1 text-xs font-bold ${
                  index === 0 ? "text-accent-300" : "text-primary-600"
                }`}
              >
                进入板块
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}